import React from 'react';
import { useTheme, alpha } from '@mui/material';
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid,
    Tooltip, Legend, ResponsiveContainer, Cell,
    PieChart, Pie,
} from 'recharts';
import { Analytics as AnalyticsIcon, Share as ShareIcon } from '@mui/icons-material';
import ChartCard from './ChartCard';
import CustomTooltip from './CustomTooltip';

export const ViewDistributionPieChart = ({ pieData, height = 340 }) => {
    const theme = useTheme();
    const emptyPie = [{ name: 'No Data', value: 1, color: theme.palette.divider }];
    const pieSlices = pieData.length > 0 ? pieData : emptyPie;

    return (
        <ChartCard title="View Distribution" icon={<ShareIcon />} height={height}>
            <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                    <Pie
                        data={pieSlices}
                        cx="50%"
                        cy="50%"
                        innerRadius={50}
                        outerRadius={80}
                        paddingAngle={2}
                        dataKey="value"
                        stroke="none"
                        label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                        labelLine={true}
                    >
                        {pieSlices.map((entry, i) => (
                            <Cell key={i} fill={entry.color} />
                        ))}
                    </Pie>
                    <Tooltip
                        contentStyle={{
                            background: theme.palette.background.paper,
                            border: `1px solid ${theme.palette.divider}`,
                            borderRadius: 12,
                            boxShadow: '0 10px 30px -10px rgba(0,0,0,0.1)',
                            color: theme.palette.text.primary,
                            fontWeight: 600,
                        }}
                        formatter={(value) => [value.toLocaleString(), 'Views']}
                    />
                </PieChart>
            </ResponsiveContainer>
        </ChartCard>
    );
};

export const ViewsBarChart = ({ chartData, height = 340 }) => {
    const theme = useTheme();
    const axisStyle = { stroke: theme.palette.text.secondary, fontSize: 12 };

    return (
        <ChartCard title="Views by Platform" icon={<AnalyticsIcon />} height={height}>
            <ResponsiveContainer width="100%" height="100%">
                <BarChart data={chartData} margin={{ top: 10, right: 10, left: 0, bottom: 5 }} barSize={32}>
                    <CartesianGrid
                        strokeDasharray="3 3"
                        stroke={alpha(theme.palette.divider, 0.4)}
                        vertical={false}
                    />
                    <XAxis
                        dataKey="platform"
                        {...axisStyle}
                        axisLine={false}
                        tickLine={false}
                        dy={10}
                    />
                    <YAxis
                        {...axisStyle}
                        axisLine={false}
                        tickLine={false}
                        dx={-10}
                        tickFormatter={(v) => (v >= 1000 ? `${(v / 1000).toFixed(0)}k` : v)}
                    />
                    <Tooltip content={<CustomTooltip />} cursor={{ fill: 'transparent' }} />
                    <Legend wrapperStyle={{ paddingTop: '10px' }} />
                    <Bar dataKey="views" name="Views" radius={[6, 6, 0, 0]}>
                        {chartData.map((entry, i) => (
                            <Cell key={i} fill={entry.color} />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </ChartCard>
    );
};
